import classNames from "classnames/bind";
import Alert from "public/icons/ui/Alert.svg";
import AlertBell from "public/icons/ui/AlertBell.svg";
import AlertOff from "public/icons/ui/AlertOff.svg";
import ArrowDown from "public/icons/ui/ArrowDown.svg";
import ArrowDownOrange from "public/icons/ui/ArrowDownOrange.svg";
import ArrowRight from "public/icons/ui/ArrowRight.svg";
import ArrowRightValuation from "public/icons/ui/ArrowRightValuation.svg";
import ArrowUp from "public/icons/ui/ArrowUp.svg";
import Badge from "public/icons/ui/Badge.svg";
import BlankTag from "public/icons/ui/BlankTag.svg";
import BlankTagInCircle from "public/icons/ui/BlankTagInCircle.svg";
import Calculator from "public/icons/ui/Calculator.svg";
import Calendar from "public/icons/ui/Calendar.svg";
import CarFront from "public/icons/ui/CarFront.svg";
import Card from "public/icons/ui/Card.svg";
import Check from "public/icons/ui/Check.svg";
import ChevronDown from "public/icons/ui/ChevronDown.svg";
import ChevronLeft from "public/icons/ui/ChevronLeft.svg";
import ChevronRight from "public/icons/ui/ChevronRight.svg";
import ChevronUp from "public/icons/ui/ChevronUp.svg";
import CircleAnimation from "public/icons/ui/CircleAnimation.svg";
import Clock from "public/icons/ui/Clock.svg";
import ClockInvertedColour from "public/icons/ui/ClockInvertedColour.svg";
import Close from "public/icons/ui/Close.svg";
import Comment from "public/icons/ui/Comment.svg";
import CopyLink from "public/icons/ui/CopyLink.svg";
import Cross from "public/icons/ui/Cross.svg";
import CurrencyExchange from "public/icons/ui/CurrencyExchange.svg";
import DeliveryVan from "public/icons/ui/DeliveryVan.svg";
import DownloadFile from "public/icons/ui/DownloadFile.svg";
import Edit from "public/icons/ui/Edit.svg";
import Email from "public/icons/ui/Email.svg";
import EmailOrange from "public/icons/ui/EmailOrange.svg";
import EmailSocialShare from "public/icons/ui/EmailSocialShare.svg";
import Error from "public/icons/ui/Error.svg";
import ExternalLink from "public/icons/ui/ExternalLink.svg";
import FAQ from "public/icons/ui/FAQ.svg";
import Facebook from "public/icons/ui/Facebook.svg";
import Fcomment from "public/icons/ui/Fcomment.svg";
import File from "public/icons/ui/File.svg";
import FileFolder from "public/icons/ui/FileFolder.svg";
import Floors from "public/icons/ui/Floors.svg";
import GeoLocation from "public/icons/ui/GeoLocation.svg";
import GridInterface from "public/icons/ui/GridInterface.svg";
import HappyFace from "public/icons/ui/HappyFace.svg";
import Hashtag from "public/icons/ui/Hashtag.svg";
import Heart from "public/icons/ui/Heart.svg";
import HeartToggled from "public/icons/ui/HeartToggled.svg";
import HomeDelivery from "public/icons/ui/HomeDelivery.svg";
import Image from "public/icons/ui/Image.svg";
import InTransit from "public/icons/ui/InTransit.svg";
import Info from "public/icons/ui/Info.svg";
import InformationICircle from "public/icons/ui/InformationICircle.svg";
import Instagram from "public/icons/ui/Instagram.svg";
import LegacyChevronDown from "public/icons/ui/LegacyChevronDown.svg";
import LinkedIn from "public/icons/ui/LinkedIn.svg";
import LiveChat from "public/icons/ui/LiveChat.svg";
import Location from "public/icons/ui/Location.svg";
import LocationPin from "public/icons/ui/LocationPin.svg";
import LocationPointer from "public/icons/ui/LocationPointer.svg";
import Mail from "public/icons/ui/Mail.svg";
import Map from "public/icons/ui/Map.svg";
import MapLocation from "public/icons/ui/MapLocation.svg";
import MapPin from "public/icons/ui/MapPin.svg";
import MotorpointCircleLogo from "public/icons/ui/MotorpointCircleLogo.svg";
import MotorpointLabelLogo from "public/icons/ui/MotorpointLabelLogo.svg";
import MyMotorpointCar from "public/icons/ui/MyMotorpointCar.svg";
import NewPlay from "public/icons/ui/NewPlay.svg";
import NobodyBeatsUs from "public/icons/ui/NobodyBeatsUs.svg";
import Notepad from "public/icons/ui/Notepad.svg";
import OrangeTick from "public/icons/ui/OrangeTick.svg";
import Pause from "public/icons/ui/Pause.svg";
import Pdf from "public/icons/ui/Pdf.svg";
import Person from "public/icons/ui/Person.svg";
import Phone from "public/icons/ui/Phone.svg";
import PhoneEmpty from "public/icons/ui/PhoneEmpty.svg";
import Play from "public/icons/ui/Play.svg";
import Plus from "public/icons/ui/Plus.svg";
import Pound from "public/icons/ui/Pound.svg";
import PriceTag from "public/icons/ui/PriceTag.svg";
import PropertyLocation2 from "public/icons/ui/PropertyLocation2.svg";
import PropertyLocation from "public/icons/ui/PropertyLocation.svg";
import QuestionMarkEncircled from "public/icons/ui/QuestionMarkEncircled.svg";
import ReserveOnline from "public/icons/ui/ReserveOnline.svg";
import RoundedError from "public/icons/ui/RoundedError.svg";
import RoundedTick from "public/icons/ui/RoundedTick.svg";
import SaveCalculator from "public/icons/ui/SaveCalculator.svg";
import Search from "public/icons/ui/Search.svg";
import SmallStar from "public/icons/ui/SmallStar.svg";
import SpecialTick from "public/icons/ui/SpecialTick.svg";
import Stopwatch from "public/icons/ui/Stopwatch.svg";
import TagInCircle from "public/icons/ui/TagInCircle.svg";
import Tel from "public/icons/ui/Tel.svg";
import ThumbsDown from "public/icons/ui/ThumbsDown.svg";
import ThumbsDownActive from "public/icons/ui/ThumbsDownActive.svg";
import ThumbsUp from "public/icons/ui/ThumbsUp.svg";
import ThumbsUpActive from "public/icons/ui/ThumbsUpActive.svg";
import Tick from "public/icons/ui/Tick.svg";
import TickGreenEncircled from "public/icons/ui/TickGreenEncircled.svg";
import TickOrangeEncircled from "public/icons/ui/TickOrangeEncircled.svg";
import Timeline from "public/icons/ui/Timeline.svg";
import WarningTriangle from "public/icons/ui/TriangleWarning.svg";
import Twitter from "public/icons/ui/Twitter.svg";
import Url from "public/icons/ui/Url.svg";
import Video from "public/icons/ui/Video.svg";
import VolumeHigh from "public/icons/ui/VolumeHigh.svg";
import VolumeLow from "public/icons/ui/VolumeLow.svg";
import VolumeMid from "public/icons/ui/VolumeMid.svg";
import VolumeMute from "public/icons/ui/VolumeMute.svg";
import Warning from "public/icons/ui/Warning.svg";
import Warranty from "public/icons/ui/Warranty.svg";
import Whatsapp from "public/icons/ui/Whatsapp.svg";
import Youtube from "public/icons/ui/Youtube.svg";
import YoutubeLabel from "public/icons/ui/YoutubeLabel.svg";
import Zip from "public/icons/ui/Zip.svg";

import styles from "./UIIcon.module.scss";

const cx = classNames.bind(styles);

export const BACKGROUNDABLE_ICONS = {
    WarningTriangle,
    TickOrangeEncircled,
    TickGreenEncircled,
    LegacyChevronDown,
    ArrowRight,
    ArrowUp,
    ArrowDown,
    ArrowDownOrange,
    Calculator,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Badge,
    Comment,
    CopyLink,
    Email,
    EmailSocialShare,
    ExternalLink,
    Facebook,
    GeoLocation,
    Heart,
    Fcomment,
    HeartToggled,
    Instagram,
    MapPin,
    MyMotorpointCar,
    NewPlay,
    Pause,
    Person,
    Phone,
    PhoneEmpty,
    Play,
    Search,
    Tick,
    Twitter,
    Url,
    Whatsapp,
    Youtube,
    HomeDelivery,
    NobodyBeatsUs,
    ReserveOnline,
    Timeline,
    SpecialTick,
    RoundedTick,
    RoundedError,
    HappyFace,
    LocationPointer,
    Location,
    LocationPin,
    FileFolder,
    DownloadFile,
    Notepad,
    MapLocation,
    Clock,
    SmallStar,
    CarFront,
    CurrencyExchange,
    GridInterface,
    Mail,
    Tel,
    Video,
    Warranty,
    Pound,
    PropertyLocation,
    PropertyLocation2,
    Map,
    Info,
    Hashtag,
    Calendar,
    Floors,
    Check,
    AlertOff,
    Alert,
    FAQ,
    LinkedIn,
    InTransit,
    Warning,
    InformationICircle,
    Stopwatch,
    BlankTagInCircle,
    TagInCircle,
    ArrowRightValuation,
    LiveChat,
    EmailOrange,
    AlertBell,
} as const;

export const NON_BACKGROUNDABLE_ICONS = {
    Card,
    Close,
    Cross,
    ClockInvertedColour,
    Edit,
    Error,
    Image,
    MotorpointLabelLogo,
    OrangeTick,
    Plus,
    VolumeHigh,
    VolumeLow,
    VolumeMid,
    VolumeMute,
    YoutubeLabel,
    QuestionMarkEncircled,
    DeliveryVan,
    ThumbsDown,
    ThumbsUp,
    ThumbsUpActive,
    ThumbsDownActive,
    PriceTag,
    BlankTag,
    SaveCalculator,
    MotorpointCircleLogo,
    CircleAnimation,
    Zip,
    Pdf,
    File,
} as const;

interface BaseProps {
    className?: string;
    color?: string;
    svgProps?: object;
}

export interface UIIconProps extends BaseProps {
    icon: keyof typeof NON_BACKGROUNDABLE_ICONS | keyof typeof BACKGROUNDABLE_ICONS;
    bgColor?: string;
}

const ICONS = { ...NON_BACKGROUNDABLE_ICONS, ...BACKGROUNDABLE_ICONS };

const UIIcon = (props: UIIconProps) => {
    const { color, icon, svgProps } = props;
    const Svg = ICONS[icon];

    const className = [props.className, cx("UIIcon")].join(" ");
    interface ColorProps extends React.CSSProperties {
        ["--icon-color"]: string | undefined;
        ["--icon-bg-color"]: string | undefined;
    }

    const style: ColorProps = {
        ["--icon-color"]: color,
        ["--icon-bg-color"]: "bgColor" in props ? props.bgColor : undefined,
    };

    return (
        <figure className={className} style={style}>
            <Svg {...svgProps} />
        </figure>
    );
};

export default UIIcon;
